import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2e955ff8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "user-customer-form" }
const _hoisted_2 = { class: "user-customer-form__title" }
const _hoisted_3 = { class: "user-customer-form__content" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "user-customer-name" }, "Получатель", -1))
const _hoisted_5 = {
  key: 0,
  class: "mo-form-group__error error"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "user-customer-phone" }, "Телефон", -1))
const _hoisted_7 = {
  key: 0,
  class: "mo-form-group__error error"
}
const _hoisted_8 = { class: "user-customer-form__controls" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.title), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        class: _normalizeClass(["mo-form-group mo-form-group--required mo-form-group--line", {
          'mo-form-group--error': _ctx.errors.fullName,
        }])
      }, [
        _hoisted_4,
        _withDirectives(_createElementVNode("input", {
          id: "user-customer-name",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.fullName) = $event)),
          type: "text",
          class: _normalizeClass({
            'base-input': true,
            'base-input--black': true,
          })
        }, null, 512), [
          [_vModelText, _ctx.fullName]
        ]),
        (_ctx.errors.fullName)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.errors.fullName), 1))
          : _createCommentVNode("", true)
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["mo-form-group mo-form-group--required mo-form-group--line", {
          'mo-form-group--error': _ctx.errors.phone,
        }])
      }, [
        _hoisted_6,
        _withDirectives(_createElementVNode("input", {
          id: "user-customer-phone",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.phone) = $event)),
          placeholder: "+7 (xxx) xxx-xx-xx",
          type: "text",
          class: _normalizeClass({
            'base-input': true,
            'base-input--black': true,
          }),
          onMaska: _cache[2] || (_cache[2] = ($event: any) => (_ctx.phoneRaw = `+7${$event.target.dataset.maskRawValue}`)),
          onInput: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.$filters.replaceFirstEight && _ctx.$filters.replaceFirstEight(...args)))
        }, null, 544), [
          [_vModelText, _ctx.phone],
          [_directive_maska, _ctx.mask]
        ]),
        (_ctx.errors.phone)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.errors.phone), 1))
          : _createCommentVNode("", true)
      ], 2),
      _createElementVNode("div", _hoisted_8, [
        (!_ctx.isNew)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "base-btn base-btn--default",
              type: "button",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.remove && _ctx.remove(...args)))
            }, " Удалить "))
          : _createCommentVNode("", true),
        (_ctx.canClose)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              class: "base-btn base-btn--default",
              type: "button",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('close')))
            }, " Отменить "))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          class: _normalizeClass(["base-btn base-btn--default", {
            'base-btn--disabled': !_ctx.meta.valid,
          }]),
          type: "button",
          onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
        }, " Сохранить ", 2)
      ])
    ])
  ]))
}